import gql from 'graphql-tag';
import { smallOverlay } from '../fragments/overlay';
export const overlaySubscription = gql `
  subscription updatedOverlay($id: Float!) {
    updatedOverlay(id: $id) {
      ...SmallOverlay
    }
  }
  ${smallOverlay}
`;
//# sourceMappingURL=overlay.js.map